export default __webpack_public_path__ + "static/media/logo.c185453b.png";